
import React from 'react'
import './ContactWrapper.css'

function ContactWrapper() {
  return (
    <div className="contact-page-wrapper">
      {/* 1. Hero Section - Centered Heading */}
      <section className="contact-hero">
        <div className="container">
          <div className="sec-title">
            <span>Get in touch</span>
            <h2>We're here to help you grow. <br/>Reach out to our experts.</h2>
          </div>
        </div>
      </section>

      {/* 2. Priority Section - Centered Form Card */}
      <section className="form-container-centered">
        <div className="container">
          <div className="elegant-form-card wow animate fadeInUp" data-wow-delay="200ms">
            <h3>Send Us a Message</h3>
            <form action="#" method="post">
              <div className="form-grid">
                <div className="input-group form-full">
                  <input className="elegant-input" type="text" name="name" placeholder="Full Name" required />
                </div>
                <div className="input-group">
                  <input className="elegant-input" type="email" name="email" placeholder="Email Address" required />
                </div>
                <div className="input-group">
                  <input className="elegant-input" type="text" name="subject" placeholder="Subject" />
                </div>
                <div className="input-group form-full">
                  <textarea className="elegant-input elegant-textarea" name="message" placeholder="How can we help you?" required />
                </div>
              </div>
              <div className="submit-btn-wrap">
                <button type="submit" className="elegant-submit-btn">Send Your Message</button>
              </div>
            </form>
          </div>

          {/* 3. Info Cards Section - 3 Columns Centered */}
          <div className="contact-info-grid">
            <div className="info-card-elegant wow animate fadeInUp" data-wow-delay="300ms">
              <i className="fas fa-map-marker-alt" />
              <h3>Our Offices</h3>
              <p>Rooty Hill, Sydney, Australia</p>
              <p>Wollert, Melbourne, Australia</p>
              <p>Kathmandu, Nepal</p>
            </div>
            
            <div className="info-card-elegant wow animate fadeInUp" data-wow-delay="400ms">
              <i className="fas fa-phone-alt" />
              <h3>Call Us</h3>
              <a href="tel:0457135403">+61 457135403</a>
              <a href="tel:9847135403">+977 9749405900</a>
            </div>

            <div className="info-card-elegant wow animate fadeInUp" data-wow-delay="500ms">
              <i className="far fa-envelope" />
              <h3>Expert Support</h3>
              <a href="mailto:hi@dlplatforms.com">hi@dlplatforms.com</a>
              <a href="mailto:support@dlplatforms.com">support@dlplatforms.com</a>
            </div>
          </div>

          {/* 4. Social Links */}
          <div className="social-links-centered">
            <a rel="noopener noreferrer" href="https://www.facebook.com/"><i className="fab fa-facebook-f" /></a>
            <a rel="noopener noreferrer" href="https://www.twitter.com/"><i className="fab fa-twitter" /></a>
            <a rel="noopener noreferrer" href="https://www.pinterest.com/"><i className="fab fa-pinterest-p" /></a>
            <a rel="noopener noreferrer" href="https://www.instagram.com/"><i className="fab fa-instagram" /></a>
          </div>

          {/* 5. Map Section - Large and Centered */}
          <div className="map-section-centered wow animate fadeInUp">
            <iframe 
              src="https://maps.google.com/maps?q=rooty%20hill&t=&z=9&ie=UTF8&iwloc=&output=embed" 
              title="Global Office Location" 
            />
          </div>
        </div>
      </section>
    </div>
  )
}

export default ContactWrapper